export const TimesheetSubmitResult = Object.freeze({
  /**
   * The booking the client was attempting to submit was already approved for
   * invoicing but an invoice hasn't been generated yet.
   */
  alreadyApprovedForInvoice: 'alreadyApprovedForInvoice',
  /**
   * The booking the client was attempting to submit was already invoiced.
   */
  alreadyInvoiced: 'alreadyInvoiced',
  /**
   * The booking the client was attempting to submit was already cancelled.
   */
  alreadyCancelled: 'alreadyCancelled',
  /**
   * The booking the client was attempting to submit has already had a timesheet
   * submitted for it.
   */
  alreadyActioned: 'alreadyActioned',
  /**
   * The client successfully submitted the booking and it is now under review.
   */
  pendingReview: 'pendingReview',
  /**
   * The client successfully submitted the booking and it is now pending invoice.
   */
  approvedForInvoice: 'approvedForInvoice',
  /**
   * Both the client and candidate stated the booking did not happen.
   */
  bookingCancelled: 'bookingCancelled',
})
